import { gql } from "apollo-boost";

export const GET_OBJETIVES = gql`
  query AsistantsObjectives($id: ID!) {
    AsistantsObjectivesQuery(id: $id) {
      orderIndex
      activities {
        id
        title
        orderIndex
      }
    }
  }
`;